import { useRailVisitBreadcrumbs } from '@planning/hooks/useRailVisitBreadcrumbs'
import { IRailVisitItem } from '@planning/rt-stores/railVisit/RailVisitItem'
import { Breadcrumbs, Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  railVisitItem: IRailVisitItem
}

export const RailVisitDashboardHeader: FC<Props> = observer(({ railVisitItem }) => {
  const { breadcrumbs, railVisitLabel } = useRailVisitBreadcrumbs(railVisitItem)

  if (!railVisitItem) return <></>

  const title = breadcrumbs.map(b => b.label).join(' - ')

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Breadcrumbs items={breadcrumbs} />

      <Header title={railVisitLabel} position='relative' />
    </>
  )
})
